export default "__VITE_ASSET__CsUoM9uh__"